/**
 * Générateur — Automatisme : partager une somme entre deux personnes
 * proportionnellement à leur âge.
 * Attendu ID : 1251 | Niveau : 3ème | Domaine : Proportionnalité
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 19, ligne 1388 :
 * « deux personnes âgées de 20 et 30 ans » ; l'âge est la variable, 20 et 30
 * la fiche, hors plage 8..16).
 *
 * Les clés age_* de gen_1249 (un fichier « partages », trois jeux de clés,
 * modèle 1101/1105) : le ratio des âges. Les payloads portent déjà
 * l'attendu 1251.
 */
import { genererParmi, CATEGORIES_AGE } from './gen_1249';

export const CATEGORIES = CATEGORIES_AGE;
const CLES = CATEGORIES_AGE.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
